var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('match-list',{key:this.$route.path + _vm.isActive('page', 'main') + _vm.isActive('page', 'sports') + _vm.isActive('page', 'upcoming') + _vm.$i18n.locale,attrs:{"scrollbar-name":"home-overview"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-486a4de5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/main/live/View.vue
// module id = null
// module chunks = 